import React from "react";
import PropTypes from "prop-types";
import { InputText, Label } from "../../../../components/Inputs";

const getState = (model) => {
  return {
    nGumPartner: model.nGumPartner || "",
    delphiGroup: model.delphiGroup || "",
    delphiComments: model.delphiComments || "",
    schulungsportalId: model.schulungsportalId || "",
  };
};

function ITDataForm({
  forwardedRef,
  className = "",
  model = {
    nGumPartner: "",
    delphiGroup: "",
    delphiComments: "",
    schulungsportalId: "",
  },
  namePrefix = "",
  disabled: _disabled,
  readOnly,
}) {
  const disabled = readOnly || _disabled;
  const [state, setState] = React.useState(getState(model));
  const handleChange = React.useCallback((key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const validate = React.useCallback(() => {
    const { ...model } = state;
    return model;
  }, [state]);

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  return (
    <div className={className}>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor={`${namePrefix}nGumPartner`}>
            {`nGum Partner Company`}
          </Label>
          <InputText
            id={`${namePrefix}nGumPartner`}
            data-test-id={`${namePrefix}nGumPartner`}
            className={`w3-block w3-border`}
            value={state.nGumPartner}
            onChange={(event) =>
              handleChange("nGumPartner", event.target.value)
            }
            disabled={disabled}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor={`${namePrefix}schulungsportalId`}>
            {`ID Schulungsportal`}
          </Label>
          <InputText
            id={`${namePrefix}schulungsportalId`}
            data-test-id={`${namePrefix}schulungsportalId`}
            className={`w3-block w3-border pad round-input`}
            value={state.schulungsportalId}
            // onChange={(event) => handleChange("schulungsportalId", event.target.value)}
            // disabled={disabled}
            readonly
          />
        </div>
      </div>
      <div className="w3-row neg-margin-lr">
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor={`${namePrefix}delphiGroup`}>
            {`Delphi Kräftegruppe`}
          </Label>
          <InputText
            id={`${namePrefix}delphiGroup`}
            data-test-id={`${namePrefix}delphiGroup`}
            className={`w3-block w3-border`}
            value={state.delphiGroup}
            onChange={(event) =>
              handleChange("delphiGroup", event.target.value)
            }
            disabled={disabled}
          />
        </div>
        <div className="w3-col s6 pad-lr pad-top form-group-item">
          <Label htmlFor={`${namePrefix}delphiComments`}>
            {`Delphi Kurzbezeichnung`}
          </Label>
          <InputText
            id={`${namePrefix}delphiComments`}
            data-test-id={`${namePrefix}delphiComments`}
            className={`w3-block w3-border`}
            value={state.delphiComments}
            onChange={(event) =>
              handleChange("delphiComments", event.target.value)
            }
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}

ITDataForm.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  model: PropTypes.shape({
    nGumPartner: PropTypes.string,
    delphiGroup: PropTypes.string,
    delphiComments: PropTypes.string,
    schulungsportalId: PropTypes.string,
  }),
  namePrefix: PropTypes.string,
  disabled: PropTypes.bool,
};

export default React.forwardRef((props, ref) => (
  <ITDataForm {...props} forwardedRef={ref} />
));
